import { MainLayout } from "@components/layouts/MainLayout";
import { Database } from "lucide-react";
import { PageHeader } from "@components/layouts/PageHeader";
import { Separator } from "@components/ui/separator";
import ApiData from "@components/settings/data/ApiData";
import AiData from "@components/settings/data/AiData";

export default function Data() {
  return (
    <MainLayout>
      <div className="space-y-6 p-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-2">
          <PageHeader
            icon={<Database className="h-6 w-6 text-blue-600" />}
            title="Data"
            subtitle="Configure your data settings."
          />
        </div>
        <Separator className="mb-12" />
        <div className="space-y-8">
          <div className="pt-4 pb-4">
            <ApiData />
          </div>
          <div className="pt-4 pb-4">
            <AiData />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}
